import { Page } from 'iconoir-react';
import React from 'react'
import { domain_need } from '../../../../Urls/Services/Api_urls';

const Contratobutton2 = (props) => {

    const tableMeta = props.tableMeta;
  const allowedStatus = new Set(["Firmado", "Orden creada", "En Proceso", "Por Firmar", "Recibida" ]);
  allowedStatus.has(tableMeta.is_actived)
    if (allowedStatus.has(tableMeta.is_actived)) {
      return (
        <button
        type='button'
        className='p-1 cursor-pointer bg-colorsecondarygreen hover:bg-colorprimarygreen text-white rounded-md '
        onClick={() => {
            window.open(domain_need + "/PruebaDocData/" + tableMeta.id);
            //test
          }}
          title="Ver contrato"
        >
          <Page
            style={{
              width: "16px",
            }}
          />
        </button>
      );
    } else{
      return null;
    }
  };

  export default Contratobutton2;

